export type SidebarItems = "home" | "data" | "design" | "share" | "cover-letter";
export type ViewTypes = "builder" | "analytics" | "job-description";

type ViewStore = {
  activeView: ViewTypes;
  setActiveView: (view: ViewTypes) => void;
  activeSidebar: SidebarItems;
  setActiveSidebar: (sidebar: SidebarItems) => void;
};

import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

export const useViewStore = create<ViewStore>()(
  immer((set) => ({
    activeView: "analytics",
    activeSidebar: "data",
    setActiveView: (view) =>
      set((state) => {
        state.activeView = view;
      }),
    setActiveSidebar: (sidebar) =>
      set((state) => {
        state.activeSidebar = sidebar;
      }),
  })),
);
